import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { HighlightIcon } from '../../components/Icons';
import StyleTypes from '../../types/StyleTypes';
import renderMarks from '../utils/renderMarks';
import makeKeyboardCommandShortcut from '../utils/makeKeyboardCommandShortcut';
import makeMarkdownInlineShortcut from '../utils/makeMarkdownInlineShortcut';
import serializers from './serializers';
import makeToolbarButton, { BASIC_SELECTION, EXPANDED_SELECTION } from '../utils/makeToolbarButton';
import renderToolbarPrompt from '../utils/renderToolbarPrompt';
import ToolbarPrompt from '../../components/ToolbarPrompt';
import ColorPicker from './components/ColorPicker';
var DEFAULT_HIGHLIGHT_COLOR = '#64EB93';
export default function HighlightPlugin() {
  return [{
    serializers: serializers,
    queries: {
      getActiveHighlight: function getActiveHighlight(editor) {
        return editor.value.activeMarks.find(function (mark) {
          return StyleTypes.HIGHLIGHT === mark.type;
        });
      }
    },
    commands: {
      setHighlight: function setHighlight(editor) {
        var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_HIGHLIGHT_COLOR;
        editor.command('removeSelectionHighlights');
        editor.addMark({
          type: StyleTypes.HIGHLIGHT,
          data: {
            color: color
          }
        });
      },
      toggleHighlight: function toggleHighlight(editor) {
        var activeHighlight = editor.query('getActiveHighlight');

        if (activeHighlight) {
          return editor.removeMark(activeHighlight);
        }

        editor.command('setHighlight');
      },
      removeSelectionHighlights: function removeSelectionHighlights(editor) {
        editor.value.marks.forEach(function (mark) {
          if (mark.type === StyleTypes.HIGHLIGHT) {
            editor.removeMark(mark);
          }
        });
      }
    }
  }, renderMarks(_defineProperty({}, StyleTypes.HIGHLIGHT, function (props) {
    var currentColor = props.mark.data.get('color') || DEFAULT_HIGHLIGHT_COLOR;
    return React.createElement("mark", {
      "data-type": "highlight",
      style: {
        backgroundColor: "".concat(currentColor, "66"),
        borderRadius: 1.5,
        paddingTop: 5,
        paddingBottom: 5
      }
    }, props.children);
  })), renderToolbarPrompt(_defineProperty({}, StyleTypes.HIGHLIGHT, function (props) {
    return React.createElement(ToolbarPrompt, Object.assign({}, props, {
      input: ColorPicker,
      inputProps: {
        editor: props.editor
      },
      withSubmit: false,
      style: {
        width: 255
      }
    }));
  })), makeToolbarButton(StyleTypes.HIGHLIGHT, {
    icon: HighlightIcon,
    title: 'Highlight',
    visibility: BASIC_SELECTION | EXPANDED_SELECTION,
    isActive: function isActive(editor) {
      return editor.isActiveMark(StyleTypes.HIGHLIGHT);
    },
    onApply: function onApply(editor) {
      return editor.command('openPrompt', StyleTypes.HIGHLIGHT);
    }
  }), makeKeyboardCommandShortcut('mod+e', {
    type: StyleTypes.HIGHLIGHT,
    command: function command(editor) {
      return editor.command('toggleHighlight');
    },
    canApply: function canApply(editor) {
      return editor.value.selection.isExpanded;
    }
  }), makeMarkdownInlineShortcut(/(::.+::)$/, /::(.+)::/, StyleTypes.HIGHLIGHT)];
}